import { render, staticRenderFns } from "./TaskDelayModal.vue?vue&type=template&id=0674af34&scoped=true"
import script from "./TaskDelayModal.vue?vue&type=script&lang=js"
export * from "./TaskDelayModal.vue?vue&type=script&lang=js"
import style0 from "./TaskDelayModal.vue?vue&type=style&index=0&id=0674af34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0674af34",
  null
  
)

export default component.exports